import { jsx as _jsx } from "react/jsx-runtime";
import { EditableComponent, } from "@adobe/aem-react-editable-components";
const withAuthoringValidation = (Component, config) => {
    return (props) => {
        const componentProps = config?.getProps?.(props) ?? props;
        if (config.isEmpty(props))
            return null;
        return _jsx(Component, { ...componentProps });
    };
};
export function withEditConfig(Component, config) {
    return function (props) {
        return (_jsx(EditableComponent, { config: config, ...props, children: _jsx(Component, { ...props }) }));
    };
}
export const withAemAuthoring = (Component, config) => {
    return withEditConfig(withAuthoringValidation(Component, config), config);
};
